import React, { useContext, useState } from 'react';

import CMTextButton from '../../../components/cm-text-button/cm-text-button.component';

import { AuthContext } from '../../../context/auth/auth.context';
import { SnackbarContext } from '../../../context/snackbar/snackbar.context';

import { cancelSubscription } from '../../../services/users/users.service';

const AdminCancelSubscription = ({ fullName, userId, testid, onSuccess }) => {
  const { authToken } = useContext(AuthContext);
  const { showSnackbar } = useContext(SnackbarContext);

  const [loading, setLoading] = useState(false);

  const handleCancelSubscription = () => {
    if (
      !window.confirm(
        `${fullName}'s subscription will be canceled. Are you sure?`
      )
    )
      return;

    setLoading(true);
    cancelSubscription(userId, authToken)
      .then(() => {
        showSnackbar({
          severity: 'success',
          message: 'Subscription canceled.',
        });
        onSuccess();
      })
      .catch(err => {
        const errorMessage = err?.response?.data?.args?.[0] ?? '';
        const formattedErrorMessage = errorMessage
          .replace('! check_args - ', '')
          .replace(/[{}]/g, '');
        showSnackbar({
          severity: 'error',
          message: formattedErrorMessage || 'Something wrong happened.',
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <CMTextButton
      data-testid={`${testid}.cancelSubscriptionButton`}
      onClick={handleCancelSubscription}
      loading={loading}
      disabled={loading}
    >
      Cancel Subscription
    </CMTextButton>
  );
};

export default AdminCancelSubscription;
